import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/tags";

export const tagsApi = {
  list: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  search: (q: string, params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    searchParams.set("q", q);
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/search?${searchParams.toString()}`);
  },

  getById: (id: string) => apiGet<{ data: Record<string, unknown> }>(`${BASE}/${id}`),

  create: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(BASE, body),

  update: (id: string, body: Record<string, unknown>) => apiPut<{ data: Record<string, unknown> }>(`${BASE}/${id}`, body),

  delete: (id: string) => apiDelete<{ data: Record<string, unknown> }>(`${BASE}/${id}`),
};